import {
  Feature,
  Service,
  PortfolioItem,
  Testimonial,
  NavItem,
  Industry,
  Client,
  PricingPlan,
} from "../types";

export const navItems: NavItem[] = [
  { id: 1, label: "Home", href: "/" },
  {
    id: 6,
    label: "Plugins",
    href: "#plugins",
    submenu: [
      {
        id: 1,
        label: "Moiz Subscriptions Pro",
        href: "/moiz-subscriptions-pro",
        description: "Premium WooCommerce subscription plugin inside out",
      },
      {
        id: 2,
        label: "Moiz Booking Pro",
        href: "/moiz-booking-pro",
        description:
          "Premium appointment booking and scheduling system for WordPress",
      },
    ],
  },
  {
    id: 2,
    label: "Industries",
    href: "#industries",
    submenu: [
      {
        id: 1,
        label: "Law Firms",
        href: "/law-firm-website-design",
        description: "Legal practice websites and digital solutions",
      },
      {
        id: 5,
        label: "Real Estate",
        href: "/real-estate-ai-representation-infrastructure",
        description:
          "AI representation infrastructure for real estate agencies & brokerages",
      },
      {
        id: 2,
        label: "Nonprofit Organizations",
        href: "/nonprofit-website-design",
        description: "Mission-driven digital presence",
      },
      {
        id: 3,
        label: "Industrial",
        href: "/industrial-website-design",
        description: "Manufacturing and industrial sector solutions",
      },
      {
        id: 4,
        label: "Home Services",
        href: "/websites-for-home-service-businesses",
        description: "Local service business websites",
      },
      {
        id: 6,
        label: "Hotel & Hospitality Finance Studio",
        href: "/ehms-decision-studio",
        description:
          "Automated USALI 12 trial balance ingestion & financial decision engine",
      },
    ],
  },
  {
    id: 3,
    label: "Services",
    href: "#services",
    submenu: [
      {
        id: 2,
        label: "Shopify Development",
        href: "/shopify-development",
        description:
          "Enterprise-grade Shopify storefronts and custom architecture",
      },
      {
        id: 3,
        label: "Website Development",
        href: "/website-development",
        description: "Full-stack web development",
      },
      {
        id: 4,
        label: "Ecommerce Website Design",
        href: "/ecommerce",
        description: "Online store development",
      },
      {
        id: 5,
        label: "MVP Development",
        href: "/mvp-development",
        description: "Minimum viable product development",
      },
      {
        id: 6,
        label: "MERN Stack Development",
        href: "/mern-stack-development",
        description: "MongoDB, Express, React, Node.js",
      },
      {
        id: 7,
        label: "Price Comparison",
        href: "/price-comparison-website-development",
        description: "Competitive pricing analysis and comparison tools",
      },
      {
        id: 8,
        label: "High-Performance Website",
        href: "/high-performance-website",
        description: "Speed, credibility, and automation for 2026",
      },
      {
        id: 9,
        label: "GEO Expert",
        href: "/geo-expert",
        description: "Generative Engine Optimization for the AI era",
      },
      {
        id: 10,
        label: "Pay For Result",
        href: "/pay-for-result",
        description: "Performance-based marketing with zero upfront risk",
      },
      {
        id: 11,
        label: "Headless WordPress",
        href: "/headless-wordpress",
        description: "Future-proof your site with React/Next.js architecture",
      },
      {
        id: 12,
        label: "WordPress Maintenance",
        href: "/wordpress-maintenance",
        description: "Expert maintenance and support for your WordPress site",
      },
      {
        id: 13,
        label: "Hire WordPress Developers",
        href: "/hire-wordpress-developers",
        description:
          "Hire elite WordPress specialists for your next big project",
      },
      {
        id: 14,
        label: "Affiliate Marketing Engine",
        href: "/affiliate-marketing-engine",
        description:
          "Build your automated affiliate marketing digital asset with FMTC & AI",
      },
      {
        id: 15,
        label: "MoizWP CRM",
        href: "/moizwp-crm",
        description:
          "High-velocity lead management and performance-driven team engine",
      },
      {
        id: 16,
        label: "Linkedin Outreach Engagement",
        href: "/linkedin-outreach-engagement",
        description:
          "100% human, high-value daily comments & executive outreach with zero password sharing",
      },
    ],
  },
  {
    id: 8,
    label: "Automation",
    href: "#automation",
    submenu: [
      {
        id: 1,
        label: "WhatsApp Intake Automation",
        href: "/whatsapp-intake-automation",
        description:
          "Scale your client intake and qualify leads 24/7 inside WhatsApp",
      },
      {
        id: 2,
        label: "Workflow Automations Development",
        href: "/workflow-automations-development",
        description:
          "100% owned self-hosted n8n, AI agents & zero-SaaS-fee microservices",
      },
    ],
  },
  { id: 4, label: "Process", href: "/process" },
  { id: 5, label: "Blog", href: "/blog" },
  // Clients removed from header; moved to footer per request
  { id: 7, label: "Pricing", href: "/pricing" },
];

export const industries: Industry[] = [
  {
    id: 1,
    name: "Law Firms",
    description:
      "Professional legal websites that build trust and credibility with potential clients.",
    icon: "⚖️",
    href: "/law-firm-website-design",
  },
  {
    id: 5,
    name: "Real Estate",
    description:
      "AI representation infrastructure & machine-readable property endpoints for real estate.",
    icon: "🏢",
    href: "/real-estate-ai-representation-infrastructure",
  },
  {
    id: 2,
    name: "Nonprofit Organizations",
    description:
      "Mission-driven websites that inspire action and increase donations.",
    icon: "🤝",
    href: "/nonprofit-website-design",
  },
  {
    id: 3,
    name: "Industrial",
    description:
      "Manufacturing and industrial sector websites that showcase expertise.",
    icon: "🏭",
    href: "/industrial-website-design",
  },
  {
    id: 4,
    name: "Home Services",
    description:
      "Local service business websites that drive customer acquisition.",
    icon: "🏠",
    href: "/websites-for-home-service-businesses",
  },
  {
    id: 6,
    name: "Hotel & Hospitality Finance",
    description:
      "eHMS Decision Studio: Automated trial balance ingestion & USALI 12 financial engine.",
    icon: "🏨",
    href: "/industry/ehms-decision-studio",
  },
];

export const services: Service[] = [
  {
    id: 1,
    icon: "💻",
    title: "Website Development",
    description:
      "Custom, responsive full-stack websites and web applications built with modern frameworks for maximum performance and conversions.",
    link: "/website-development",
  },
  {
    id: 2,
    icon: "🛍️",
    title: "Shopify Development",
    description:
      "High-performance custom themes, headless storefronts, custom apps, and Checkout Extensibility built for maximum conversions.",
    link: "/shopify-development",
  },
  {
    id: 3,
    icon: "💻",
    title: "Website Development",
    description:
      "Full-stack web development using modern technologies and best practices for optimal performance.",
    link: "/website-development",
  },
  {
    id: 4,
    icon: "🛒",
    title: "Ecommerce Website Design",
    description:
      "Complete online store solutions with secure payment processing, inventory management, and customer tracking.",
    link: "/ecommerce",
  },
  {
    id: 5,
    icon: "🚀",
    title: "MVP Development",
    description:
      "Rapid development of minimum viable products to validate business ideas and attract early adopters.",
    link: "/mvp-development",
  },
  {
    id: 6,
    icon: "⚙️",
    title: "MERN Stack Development",
    description:
      "Modern web applications built with MongoDB, Express.js, React.js, and Node.js for scalable solutions.",
    link: "/mern-stack-development",
  },
  {
    id: 7,
    icon: "⚡",
    title: "High-Performance Upgrade",
    description:
      "Transform your site into a high-converting machine with elite speed optimization, modern UI/UX, and AI automation.",
    link: "/high-performance-website",
  },
  {
    id: 8,
    icon: "🤖",
    title: "GEO Expert",
    description:
      "Optimize your brand for AI search engines like Gemini, Perplexity, and ChatGPT Search to dominate the future of search.",
    link: "/geo-expert",
  },
  {
    id: 9,
    icon: "👨‍💻",
    title: "Hire WordPress Developers",
    description:
      "Expert WordPress developers ready to build, customize, and maintain your WordPress website with professional excellence.",
    link: "/hire-wordpress-developers",
  },
  {
    id: 10,
    icon: "⚙️",
    title: "Affiliate Marketing Engine",
    description:
      "Build a high-speed, automated affiliate marketing engine with FMTC feeds and AI content rewriting.",
    link: "/affiliate-marketing-engine",
  },
  {
    id: 11,
    icon: "📊",
    title: "MoizWP CRM",
    description:
      "A unique Action-First CRM architecture built for performance-driven teams and agent activity tracking.",
    link: "/moizwp-crm",
  },
  {
    id: 12,
    icon: "🔍",
    title: "Price Comparison Platform",
    description:
      "Build an automated, Idealo-style price comparison website comparing prices from multiple stores using Awin datafeeds.",
    link: "/price-comparison-website-development",
  },
  {
    id: 13,
    icon: "⚡",
    title: "Workflow Automations Development",
    description:
      "Custom self-hosted n8n workflows, AI agents, and microservices with 100% project ownership and zero SaaS task fees.",
    link: "/workflow-automations-development",
  },
  {
    id: 14,
    icon: "💼",
    title: "Linkedin Outreach Engagement",
    description:
      "100% human daily LinkedIn engagement, decision-maker thread tracking, and 1-click publishing links with zero password sharing.",
    link: "/linkedin-outreach-engagement",
  },
];

export const clients: Client[] = [
  {
    id: 1,
    name: "Smith & Associates Law",
    logo: "⚖️",
    industry: "Law Firm",
    description:
      "Professional legal website with client portal and case management system.",
  },
  {
    id: 2,
    name: "Hope Foundation",
    logo: "🤝",
    industry: "Nonprofit",
    description:
      "Donation platform and volunteer management system for nonprofit organization.",
  },
  {
    id: 3,
    name: "Industrial Solutions Inc.",
    logo: "🏭",
    industry: "Industrial",
    description: "B2B website with product catalog and quote request system.",
  },
  {
    id: 4,
    name: "Clean Pro Services",
    logo: "🏠",
    industry: "Home Services",
    description:
      "Local service website with online booking and payment integration.",
  },
  {
    id: 5,
    name: "TechStart Ventures",
    logo: "🚀",
    industry: "Startup",
    description: "MVP development for innovative SaaS platform.",
  },
  {
    id: 6,
    name: "EcoMart",
    logo: "🛒",
    industry: "Ecommerce",
    description: "Full-featured online store with inventory management.",
  },
];

export const pricingPlans: PricingPlan[] = [
  {
    id: 1,
    name: "Starter",
    price: "$2,999",
    description: "Perfect for small businesses getting started online",
    features: [
      "5-Page Custom Website",
      "Mobile Responsive Design",
      "Contact Form",
      "Basic SEO Setup",
      "Google Analytics",
      "1 Month Support",
    ],
  },
  {
    id: 2,
    name: "Professional",
    price: "$5,999",
    description: "Ideal for growing businesses with more features",
    features: [
      "10-Page Custom Website",
      "Advanced SEO Optimization",
      "Content Management System",
      "Blog Integration",
      "Social Media Integration",
      "3 Months Support",
      "Performance Optimization",
    ],
    popular: true,
  },
  {
    id: 3,
    name: "Enterprise",
    price: "$12,999",
    description: "Complete solution for established businesses",
    features: [
      "Unlimited Pages",
      "Custom E-commerce Integration",
      "Advanced Analytics Dashboard",
      "CRM Integration",
      "Custom Functionality",
      "6 Months Support",
      "Priority Support",
      "Monthly Maintenance",
    ],
  },
];

export const features: Feature[] = [
  {
    id: 1,
    icon: "🎨",
    title: "Creative Design",
    description:
      "Unique, modern designs that capture your brand's essence and engage your audience effectively.",
  },
  {
    id: 2,
    icon: "📱",
    title: "Responsive Design",
    description:
      "Websites that look and work perfectly on all devices, from smartphones to desktop computers.",
  },
  {
    id: 3,
    icon: "⚡",
    title: "Performance Optimized",
    description:
      "Lightning-fast loading times and optimized performance for better user experience and SEO.",
  },
  {
    id: 4,
    icon: "🛡️",
    title: "24/7 Support",
    description:
      "Round-the-clock support and maintenance to ensure your website runs smoothly at all times.",
  },
  {
    id: 5,
    icon: "🔍",
    title: "SEO Optimized",
    description:
      "Built with search engine optimization in mind to help you rank higher and attract more visitors.",
  },
  {
    id: 6,
    icon: "🔒",
    title: "Secure & Safe",
    description:
      "Advanced security measures to protect your website and your customers' data from threats.",
  },
];

export const portfolioItems: PortfolioItem[] = [
  {
    id: 1,
    icon: "⚖️",
    title: "Law Firm Website",
    description: "Professional legal practice website with client portal",
  },
  {
    id: 2,
    icon: "🤝",
    title: "Nonprofit Platform",
    description: "Donation and volunteer management system",
  },
  {
    id: 3,
    icon: "🏭",
    title: "Industrial Website",
    description: "B2B manufacturing company website",
  },
  {
    id: 4,
    icon: "🏠",
    title: "Home Services",
    description: "Local service business with online booking",
  },
  {
    id: 5,
    icon: "🚀",
    title: "MVP Development",
    description: "Startup minimum viable product",
  },
  {
    id: 6,
    icon: "🛒",
    title: "E-commerce Store",
    description: "Full-featured online retail platform",
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 1,
    text: "MoizWP transformed our law practice with an amazing website that increased our client inquiries by 300%. Their team is professional, creative, and delivers exactly what they promise.",
    author: {
      name: "Sarah Mitchell",
      position: "Managing Partner, Smith & Associates",
      avatar: "SM",
    },
  },
  {
    id: 2,
    text: "Working with MoizWP was an absolute pleasure. They understood our nonprofit's mission perfectly and created a website that exceeded our expectations. Highly recommended!",
    author: {
      name: "Michael Johnson",
      position: "Executive Director, Hope Foundation",
      avatar: "MJ",
    },
  },
  {
    id: 3,
    text: "The team at MoizWP is incredibly talented and professional. They delivered our e-commerce platform on time and within budget. Our customers love the new shopping experience.",
    author: {
      name: "Emily Lopez",
      position: "Founder, EcoMart",
      avatar: "EL",
    },
  },
];
